import React from 'react'
import VideoModal from '../ModalVideo';
import { Link } from 'react-router-dom'

const About3 = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (

        <section className="about-section">
            <div className="content-area clearfix">
                <div className="left-col">
                    <div className="about-text">
                        <span>Welcome To Our Industry</span>
                        <h3>We Have 25 Years of Experience in this are, so you Can Espect From Us Better Services</h3>
                        <p>Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with</p>
                        <Link onClick={ClickHandler} to="/home" className="theme-btn-s2">Explore More</Link>
                    </div>
                </div>
                <div className="right-col">
                    <div className="video-area">
                        <div className="video-holder">
                            <VideoModal />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About3;